"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSuiAddress = exports.isValidTerraAddress = exports.isValidSolAddress = exports.validators = exports.getMessageToSign = void 0;
/**
 * https://docs.solana.com/integrations/exchange#validating-user-supplied-account-addresses-for-withdrawals
 * @param address
 */
var bech32_1 = require("bech32");
var base58_1 = require("../shared/utils/base58");
var getMessageToSign = function (address, network) {
    return "My ".concat(network, " wallet for distribution is: ").concat(address);
};
exports.getMessageToSign = getMessageToSign;
exports.validators = {
    SOL: isValidSolAddress,
    TERRA: isValidTerraAddress,
    SUI: isValidSuiAddress,
};
function isValidSolAddress(address) {
    if (!(address === null || address === void 0 ? void 0 : address.match(/^[1-9A-HJ-NP-Za-km-z]{32,44}$/)))
        return false;
    var decoded = (0, base58_1.decodeBase58)(address);
    return decoded.length == 32;
}
exports.isValidSolAddress = isValidSolAddress;
function isValidTerraAddress(address) {
    if (!address)
        return false;
    try {
        var vals = bech32_1.bech32.decode(address);
        return vals.prefix === 'terra' && address.length == 44;
    }
    catch (e) {
        return false;
    }
}
exports.isValidTerraAddress = isValidTerraAddress;
function isValidSuiAddress(address) {
    return (address === null || address === void 0 ? void 0 : address.match(/^0x[0-9A-HJ-NP-Za-km-z]{32,64}$/)) !== null;
}
exports.isValidSuiAddress = isValidSuiAddress;
